import {
	flattenDesignTokens,
	setDesignTokenValue,
	type DesignTokenSet,
	type DesignTokenType,
} from 'common/design-tokens';

export function updateStoryTokenValue(
	tokens: DesignTokenSet,
	tokenId: string,
	expectedType: DesignTokenType,
	value: unknown,
	availableFontFamilies: string[]
): DesignTokenSet {
	const token = flattenDesignTokens(tokens).find(item => item.id === tokenId);
	if (!token || token.type !== expectedType) throw new Error('Token changed. Reopen the editor and try again.');
	if (token.type === 'fontFamily' && !availableFontFamilies.includes(String(value)))
		throw new Error('Font is not available in this Story. Add it in Story Settings → Fonts first.');
	return setDesignTokenValue(tokens, tokenId, value);
}
